import { createReducer, on } from '@ngrx/store';
import { GridTableState } from '../../models/grid-customization.model';
import * as GridCustomizationActions from './grid-customization.actions';
import { AuthActions } from 'src/app/auth/action-types';

export const gridCustomizationFeatureKey = 'gridCustomization';

export interface GridCustomizationState {
  grids: Record<string, GridTableState>;
}

export const initialGridCustomizationState: GridCustomizationState = {
  grids: {},
};

export const gridCustomizationReducer = createReducer(
  initialGridCustomizationState,
  on(AuthActions.logout, (state) => initialGridCustomizationState),

  on(GridCustomizationActions.saveGridState, (state, { gridId, state: gridState }) => ({
    ...state,
    grids: {
      ...state.grids,
      [gridId]: {
        ...gridState,
        gridId,
        updatedAt: Date.now(),
      },
    },
  })),

  on(GridCustomizationActions.resetGridState, (state, { gridId }) => {
    const nextGrids = { ...state.grids };
    delete nextGrids[gridId];
    return {
      ...state,
      grids: nextGrids,
    };
  }),

  on(GridCustomizationActions.resetAllGridsState, () => initialGridCustomizationState)
);
